import api from '@/api/cardNumber';
import util from '@/libs/util.js';
import { Message } from 'element-ui';

const cardNumber = {
  namespaced: true,
  state: {
    getDataIsLoading: false,
    // 筛选：student--学生卡号，teacher--教师卡号
    typeTab: 'student',
    dataList: [],
    tableTotalCard: 0,
    classListForCard: [],
    // 修改弹窗
    editData: {
      flag: false,
      content: {}
    }
  },
  mutations: {
    SET_DATA_IS_LOADING: (state, getDataIsLoading) => {
      state.getDataIsLoading = getDataIsLoading;
    },
    SET_TYPE_TAB: (state, typeTab) => {
      state.typeTab = typeTab;
    },
    SET_DATA_LIST: (state, dataList) => {
      state.dataList = dataList;
      state.tableTotalCard = dataList.length;
    },
    SET_Table_TOTAL_CARD: (state, count) => {
      state.tableTotalCard = count;
    },
    SET_EDIT_VISIBLE: (state, editData) => {
      state.editData = editData;
    },
    SET_CLASS_LIST_FOR_CARD: (state, classListForCard) => {
      state.classListForCard = classListForCard;
    }
  },
  actions: {
    async setTypeTab({ commit }, typeTab) {
      commit('SET_TYPE_TAB', typeTab);
    },
    changeEditVisible({ commit }, data) {
      commit('SET_EDIT_VISIBLE', data);
    },
    getClassList({ commit }, requestParams) {
      return new Promise(resolve => {
        api.getClassByUser(requestParams).then(res => {
          commit('SET_CLASS_LIST_FOR_CARD', res);
          resolve();
        });
      });
    },
    editSubmit({ state, commit }, requestParams) {
      return new Promise((resolve, reject) => {
        if (state.typeTab === 'student') {
          const params = {
            ...requestParams,
            studentId: state.editData.content.studentId,
            cardNumber: state.editData.content.cardNumber || ''
          };
          api
            .updateCardNumberForStudent(params)
            .then(res => {
              console.log('res', res);
              if (res && typeof res === 'boolean') {
                Message.success('修改成功');
                commit('SET_EDIT_VISIBLE', {
                  flag: false,
                  content: {}
                });
                resolve(true);
              } else {
                Message.error(res || '修改失败');
                resolve(false);
              }
            })
            .catch(err => {
              reject(err);
            });
        } else {
          const params = {
            ...requestParams,
            userId: state.editData.content.userId,
            cardNumber: state.editData.content.cardNumber
          };
          api
            .updateCardNumberForTeacher(params)
            .then(res => {
              if (res && typeof res === 'boolean') {
                Message.success('修改成功');
                commit('SET_EDIT_VISIBLE', {
                  flag: false,
                  content: {}
                });
                resolve(true);
              } else {
                Message.error('修改失败');
                resolve(false);
              }
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    deleteCardNumber({ state, commit }, requestParams) {
      return new Promise((resolve, reject) => {
        console.log('requestParams', requestParams);
        if (state.typeTab === 'student') {
          api
            .deleteCardNumberForStudent(requestParams)
            .then(res => {
              if (res && typeof res === 'boolean') {
                Message.success('清除卡号成功');
                resolve(true);
              } else {
                Message.error('清除卡号失败');
                resolve(false);
              }
            })
            .catch(err => {
              reject(err);
            });
        } else {
          api
            .deleteCardNumberForTeacher(requestParams)
            .then(res => {
              if (res && typeof res === 'boolean') {
                Message.success('清除卡号成功');
                resolve(true);
              } else {
                Message.error('清除卡号失败');
                resolve(false);
              }
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    getDataList({ state, commit }, requestParams) {
      commit('SET_DATA_IS_LOADING', true);
      return new Promise((resolve, reject) => {
        // commit('SET_DATA_LIST', []);
        // commit('SET_Table_TOTAL_CARD', 0);
        if (state.typeTab === 'student') {
          const params = {
            ...requestParams,
            userId: util.cookies.get('uuid'),
            userType: util.cookies.get('userType')
          };
          api
            .getStudentCardNumber(params)
            .then(res => {
              if (res && res.data.length > 0) {
                commit('SET_DATA_LIST', res.data || []);
                commit('SET_Table_TOTAL_CARD', res.count || 0);
              } else {
                commit('SET_DATA_LIST', []);
                commit('SET_Table_TOTAL_CARD', 0);
              }
              commit('SET_DATA_IS_LOADING', false);
              resolve();
            })
            .catch(err => {
              commit('SET_DATA_LIST', []);
              commit('SET_Table_TOTAL_CARD', 0);
              reject(err);
            });
        } else {
          api
            .getTeacherCardNumber(requestParams)
            .then(res => {
              if (res && res.data.length > 0) {
                commit('SET_DATA_LIST', res.data || []);
                commit('SET_Table_TOTAL_CARD', res.count || 0);
              } else {
                commit('SET_DATA_LIST', []);
                commit('SET_Table_TOTAL_CARD', 0);
              }
              commit('SET_DATA_IS_LOADING', false);
              resolve();
            })
            .catch(err => {
              commit('SET_DATA_LIST', []);
              commit('SET_Table_TOTAL_CARD', 0);
              reject(err);
            });
        }
      });
    }
  }
};

export default cardNumber;
